"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditTaskTypeDialog = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const entity_ui_1 = require("@sierralabs/entity-ui");
const useCreateTaskType_1 = require("../hooks/useCreateTaskType");
const useUpdateTaskType_1 = require("../hooks/useUpdateTaskType");
const EditTaskTypeDialog = props => {
    const { open, taskType: initialTaskType, onCancel, onChange } = props;
    const onChangeRef = (0, react_1.useRef)(onChange);
    const [form, setForm] = (0, react_1.useState)({});
    const { createdTaskType, isLoading: isCreating, error: createError, createTaskType } = (0, useCreateTaskType_1.useCreateTaskType)();
    const { updatedTaskType, isLoading: isUpdating, error: updateError, updateTaskType } = (0, useUpdateTaskType_1.useUpdateTaskType)((initialTaskType === null || initialTaskType === void 0 ? void 0 : initialTaskType.id) || 0);
    const isFormValid = !!(form.name &&
        form.label &&
        form.prefix &&
        (form.entityId || form.entityTable));
    const isLoading = isCreating || isUpdating;
    const error = createError || updateError;
    (0, react_1.useEffect)(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        initialTaskType && setForm(Object.assign({}, initialTaskType));
    }, [initialTaskType]);
    (0, react_1.useEffect)(() => {
        !open && setForm({});
    }, [open]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (createdTaskType) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, createdTaskType, true);
        }
    }, [createdTaskType]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedTaskType) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, updatedTaskType, false);
        }
    }, [updatedTaskType]);
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        react_1.default.createElement(core_1.DialogTitle, null,
            initialTaskType ? 'Edit' : 'Create',
            " Task Type"),
        react_1.default.createElement("form", null,
            react_1.default.createElement(core_1.DialogContent, null,
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(core_1.TextField, { autoFocus: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Name', value: form.name || '', onChange: event => {
                            setForm(form => (Object.assign(Object.assign({}, form), { name: event.target.value })));
                        } })),
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', label: 'Label', variant: 'outlined', value: form.label || '', onChange: event => {
                            setForm(form => (Object.assign(Object.assign({}, form), { label: event.target.value })));
                        } })),
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(core_1.TextField, { fullWidth: true, size: 'small', label: 'Prefix', variant: 'outlined', value: form.prefix || '', onChange: event => {
                            setForm(form => (Object.assign(Object.assign({}, form), { prefix: event.target.value })));
                        } })),
                react_1.default.createElement(core_ui_1.ConfigFieldControl, null,
                    react_1.default.createElement(entity_ui_1.EntityPicker, { fullWidth: true, label: 'Target Entity', placeholder: 'Select Target Entity', value: form.entityId || form.entityTable || undefined, onChange: value => {
                            setForm(form => {
                                form = Object.assign({}, form);
                                Object.assign(form, { entityId: null, entityTable: null });
                                if (value === null || value === void 0 ? void 0 : value.id) {
                                    form.entityId = value.id;
                                }
                                else if (value) {
                                    form.entityTable = value.tableName;
                                }
                                return form;
                            });
                        } })),
                error && react_1.default.createElement(lab_1.Alert, { severity: 'error' }, error.message)),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
                react_1.default.createElement(core_1.Button, { type: 'submit', color: 'primary', variant: 'contained', disabled: !isFormValid, endIcon: isLoading && react_1.default.createElement(core_1.CircularProgress, { size: 20 }), onClick: e => {
                        e.preventDefault();
                        if (isFormValid) {
                            initialTaskType ? updateTaskType(form) : createTaskType(form);
                        }
                    } }, "Submit")))));
};
exports.EditTaskTypeDialog = EditTaskTypeDialog;
exports.default = exports.EditTaskTypeDialog;
//# sourceMappingURL=EditTaskTypeDialog.js.map